import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./CMNewsDetails.css";
import { useTranslation } from "react-i18next";
import axios from "axios";

export default function NewsDetails() {
  const { id } = useParams();
  const { i18n } = useTranslation();
  const lang = i18n.language || "ta";
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

useEffect(() => {
  axios
    .get(`https://admin.cmpranesh-admk.com/api/getNewsDetails.php?id=${id}`)
    .then(res => {
      setNews(res.data);
      setLoading(false);
    })
    .catch(err => {
      setError(lang === "en" ? "Post Not Found" : "பதிவு இல்லை");
      setLoading(false);
    });
}, [id, lang]);


  if (loading) return <h2>{lang === "en" ? "Loading..." : "ஏற்றுகிறது..."}</h2>;
  if (error) return <h2>{error}</h2>;

  // Safe tags handling
  const tags = (lang === "ta" ? news.tags_ta : news.tags_en) || "";
  const tagsArray = tags.split(",").map(t => t.trim()).filter(t => t);

  return (
    <section className="news-details-wrapper">
      {/* TITLE */}
      <h1 className="news-details-title">
        {lang === "ta" ? news.title_ta : news.title_en}
      </h1>

      {/* DATE */}
      <p className="news-details-date">
        {news.date ? new Date(news.date).toLocaleDateString(
          lang === "ta" ? "ta-IN" : "en-US",
          { day: "2-digit", month: "short", year: "numeric" }
        ) : ""}
      </p>

      {/* IMAGE */}
      {news.image && (
        <img
          src={`https://admin.cmpranesh-admk.com/${news.image}`}
          alt={lang === "ta" ? news.title_ta : news.title_en}
          className="news-details-image"
        />
      )}

      {/* FULL CONTENT */}
      <p className="news-details-content">
        {lang === "ta" ? news.fullContent_ta : news.fullContent_en}
      </p>

      {/* TAGS */}
      {tagsArray.length > 0 && (
        <div className="news-details-tags">
          {tagsArray.map((tag, i) => (
            <Link key={i} className="tag-chip">
              {tag}
            </Link>
          ))}
        </div>
      )}

      {/* BACK BUTTON */}
      <Link to="/news" className="back-btn">
        {lang === "en" ? "← Back to News" : "← மீண்டும் செய்திகளுக்கு"}
      </Link>
    </section>
  );
}
